import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { WeiveFormEmbed } from '@/components/marketing/weive-form-embed';
import { Spinner } from '@/components/ui/spinner';
import { contactFormKey, contactFormOrigin } from '@/lib/contact-form-config';
import { useAuthStore } from '@/stores/auth-store';

import { LandingMarketingShell, LandingReveal } from './landing-shared';
import './landing.css';

export const ContactPage = () => {
  const { t } = useTranslation('landing');
  const status = useAuthStore((state) => state.status);
  const restore = useAuthStore((state) => state.restore);
  const signedIn = status === 'authenticated';

  useEffect(() => {
    if (status === 'unknown') void restore();
  }, [status, restore]);

  if (status === 'unknown') {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-brand">
        <Spinner className="size-6 text-brand" />
      </div>
    );
  }

  return (
    <LandingMarketingShell signedIn={signedIn}>
      <main className="text-on-brand">
        <section className="py-12 sm:py-16">
          <div className="mx-auto max-w-2xl px-4 text-center sm:px-6 lg:px-8">
            <LandingReveal>
              <p className="text-caption font-semibold uppercase tracking-[0.2em] text-on-brand/75">
                {t('contact.eyebrow')}
              </p>
              <h1 className="landing-display mt-3 text-balance text-[2rem] font-semibold tracking-tight sm:text-[2.25rem]">
                {t('contact.title')}
              </h1>
              <p className="mt-4 text-pretty text-body leading-relaxed text-on-brand/90 sm:text-card-title">
                {t('contact.subtitle')}
              </p>
            </LandingReveal>
          </div>
        </section>

        <section className="landing-section-separator pb-16 sm:pb-20">
          <div className="mx-auto max-w-xl px-4 sm:px-6 lg:max-w-2xl lg:px-8">
            <LandingReveal>
              <WeiveFormEmbed
                publicKey={contactFormKey}
                formsOrigin={contactFormOrigin}
                title={t('contact.formTitle')}
              />
            </LandingReveal>
          </div>
        </section>
      </main>
    </LandingMarketingShell>
  );
};
